module.exports = __webpack_public_path__ + "img/SWP_Shield_07 (1).742780c9.png";